import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import { CircularProgress } from "@mui/material";
import AppContext from "../../container/context";

export default function Funcao(props) {
  const history = props.history;
  const [funcaoId] = useState(Number(props.match.params.id));
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState({ nome: "", ativo: false });
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (funcaoId > 0) {
      carregar();
    }
  }, []);

  const carregar = () => {
    setCarregando(true);

    api
      .get("funcoes/carregar", { id: funcaoId })
      .then((res) => {
        setDados(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar produto");
        setCarregando(false);
      });
  };

  const salvar = (params) => {
    let dadosParams = dados;
    dadosParams.nome = params.nome;
    dadosParams.ativo = params.ativo;
    if (funcaoId > 0) dadosParams.id = funcaoId;
    setDados(dadosParams);

    if (funcaoId === 0) {
      api
        .put("funcoes/inserir", dadosParams)
        .then((res) => {
          notification("success", "Função inserida!");
          setDados({ nome: "", ativo: false });
          history.push(`/app/funcao`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .post("funcoes/editar", dadosParams)
        .then((res) => {
          notification("success", "Função editada!");
          setDados({ nome: "", ativo: false });
          history.push(`/app/funcao`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fDados = {
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dados.nome,
      },
      ativo: {
        label: "Ativo",
        type: "check",
        space: 4,
        value: dados.ativo,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  return (
    <div> {carregando ? <CircularProgress /> : <Form formData={fDados} />}</div>
  );
}
